var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBalanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 128,
    viewBox: "0 0 138 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.6668 0.833008V9.35301L109 20.473L133.213 12.4063L137.433 25.0463L117.22 31.7863L137.86 88.533C130.58 96.113 120.333 100.833 109 100.833C97.6601 100.833 87.4201 96.113 80.1401 88.533L100.767 31.7863L75.6668 23.413V114.166H102.333V127.5H35.6668V114.166H62.3335V23.413L37.2135 31.7863L57.8535 88.533C50.5801 96.113 40.3335 100.833 29.0001 100.833C17.6601 100.833 7.42014 96.113 0.140137 88.533L20.7668 31.7863L0.566803 25.053L4.7868 12.3997L29.0001 20.4663L62.3335 9.35301V0.833008H75.6668ZM109 48.1863L95.9468 84.093C99.8601 86.2997 104.327 87.4997 109 87.4997C113.667 87.4997 118.133 86.2997 122.053 84.0997L109 48.1797V48.1863ZM29.0001 48.1863L15.9468 84.093C19.8601 86.2997 24.3268 87.4997 29.0001 87.4997C33.6668 87.4997 38.1335 86.2997 42.0535 84.0997L29.0001 48.1797V48.1863Z",
    fill: "#E1E1E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceIcon);
export default __webpack_public_path__ + "static/media/BalanceIcon.f9a1dee9899c41db0a9f764ed44dcb40.svg";
export { ForwardRef as ReactComponent };